import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '../store';

import { AuthState, TokenResponse, User } from './authTypes';

const initialState: AuthState = {
  user: null,
  accessToken: null,
  refreshToken: null,
  authLoading: false,
};
const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    authLoading(state) {
      state.authLoading = true;
    },
    loginSuccess(state, action: PayloadAction<{ user: User; tokens: TokenResponse }>) {
      state.user = action.payload.user;
      state.accessToken = action.payload.tokens.accessToken;
      state.refreshToken = action.payload.tokens.refreshToken;

      state.authLoading = false;
    },
    registerSuccess(state, action: PayloadAction<{ user: User; tokens: TokenResponse }>) {
      state.user = action.payload.user;
      state.accessToken = action.payload.tokens.accessToken;
      state.refreshToken = action.payload.tokens.refreshToken;

      state.authLoading = false;
    },
    logout(state) {
      state.user = null;
      state.accessToken = null;
      state.refreshToken = null;

      state.authLoading = false;
    },
    refreshTokenSuccess(
      state,
      action: PayloadAction<{ accessToken: string; refreshToken: string }>
    ) {
      state.accessToken = action.payload.accessToken;
      state.refreshToken = action.payload.refreshToken;
    },
    setUser(state, action: PayloadAction<User>) {
      state.user = action.payload;
    },
  },
});

export const { loginSuccess, registerSuccess, logout, refreshTokenSuccess, authLoading, setUser } =
  authSlice.actions;

export const selectUser = (state: RootState) => state.auth.user;
export const selectAuthLoading = (state: RootState) => state.auth.authLoading;

export default authSlice.reducer;
